const ACCEPTED_IMAGE_EXTENSIONS = '.png, .jpg, .jpeg, .gif, .bmp';

const ACCEPTED_IMAGE_MIME_TYPES = [
	'image/png',
	'image/jpg',
	'image/jpeg',
	'image/gif',
	'image/bmp'
];

const hasAcceptedImageExtension = (fileName: string): boolean => {
	const normalizedName = fileName.toLowerCase();
	return ['.png', '.jpg', '.jpeg', '.gif', '.bmp'].some((extension) =>
		normalizedName.endsWith(extension)
	);
};

const isAllowedImageFile = (file: File): boolean =>
	ACCEPTED_IMAGE_MIME_TYPES.includes(file.type) || hasAcceptedImageExtension(file.name);

export { ACCEPTED_IMAGE_EXTENSIONS, isAllowedImageFile };
